export default "__VITE_ASSET__79320588__"